import styled from 'styled-components'
import { SliderUnstyled } from './unstyled'

export const Slider = styled(SliderUnstyled)`
  position: relative;
  .value {
    float: right;
  }
  .range-values {
    display: flex;
    justify-content: space-between;
  }
  input {
    position: relative;
    width: 100%;
    border-radius: 4px;
    height: 52px;
    background: #f8f8f8;
    border: none;
    padding: ${props => (props.icon ? '0 20px 0 54px' : '0 20px')};
    color: ${props => props.theme.colors.secondary};
    font-size: ${props => props.theme.fontSizes.form.input};
    outline: none;

    ::placeholder {
      font-size: ${props => props.theme.fontSizes.form.placeholder};
      color: ${props => props.theme.colors.placeholder};
      letter-spacing: 0.6px;
    }
  }

  .icon {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 23px;
    right: auto;
    margin: auto;
  }

  .label {
    display: block;
    padding: 0;
    text-align: left;
    font-size: ${props => props.theme.fontSizes.form.label};
    color: ${props => props.theme.colors.secondary};
    font-family: ${props => props.theme.fonts.robotoRegular};
    line-height: 24px;
    margin: 0 0 10px 0;
  }
`



// WEBPACK FOOTER //
// ./src/Components/Form/Slider/index.js